import pt_BR from './pt-br.json';
import en_US from './en-us.json';

export const translations: Record<string, any> = {
  pt_BR,
  en_US,
};
